module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isConnected) ? _c('aside', {
    ref: "mainSidebar",
    staticClass: "main-sidebar",
    on: {
      "scroll": _vm.placeLiSpan
    }
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu",
    on: {
      "click": _vm.onActivityClick,
      "mousemove": _vm.placeLiSpan
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "ImproveYourExperience"
      }
    }
  }, [_c('div', {
    staticClass: "relative inline"
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o light",
    class: {
      animateLight: _vm.nbImprovements
    }
  })]), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.improveYourExperience")))])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "News",
        params: _vm.defaultRouteParams
      }
    }
  }, [_c('div', {
    staticClass: "relative inline"
  }, [_c('i', {
    staticClass: "fa fa-bell-o",
    class: {
      animateRing: _vm.hasNews
    }
  })]), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.news")))])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "Events",
        params: _vm.defaultRouteParams
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.eventsBus.$emit(_vm.eventsBus.CLICK_ON_SIDEBAR)
      }
    }
  }, [_c('div', {
    staticClass: "relative inline"
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.events")))])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "Conversations",
        params: _vm.defaultRouteParams
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.eventsBus.$emit(_vm.eventsBus.CLICK_ON_SIDEBAR)
      }
    }
  }, [_c('div', {
    staticClass: "relative inline"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), (_vm.conversationsUpdateCount > 0) ? _c('div', {
    staticClass: "badge info"
  }, [_vm._v(_vm._s(_vm.conversationsUpdateCount))]) : _vm._e()]), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.messages")))])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/nodes"
    }
  }, [_c('div', {
    staticClass: "relative inline"
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  })]), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.files")))])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "Polls",
        params: _vm.defaultRouteParams
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.polls")))])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "Members",
        params: _vm.defaultRouteParams
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.eventsBus.$emit(_vm.eventsBus.CLICK_ON_SIDEBAR)
      }
    }
  }, [_c('div', {
    staticClass: "relative inline"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })]), (!_vm.isAllGroopsSelected) ? _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.members")))]) : _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.contacts")))])])], 1), (!_vm.isAllGroopsSelected && !_vm.isPersonalGroopSelected) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "GroupManagement",
        params: _vm.defaultRouteParams
      }
    }
  }, [_c('div', {
    staticClass: "relative inline"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })]), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.groupManagement")))])])], 1) : _vm._e(), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "GroupPage",
        params: _vm.defaultRouteParams
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.groupPages")))])])], 1), (_vm.user && _vm.user.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "Administration"
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.administration")))])])], 1) : _vm._e(), (_vm.invitations.length > 0 || _vm.invitationsToAccept.length > 0) ? [_c('hr'), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: "Invitations",
        params: _vm.defaultRouteParams
      }
    }
  }, [_c('div', {
    staticClass: "relative inline"
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  }), ((_vm.pendingInvitations.length + _vm.pendingInvitationsToAccept.length) > 0) ? _c('div', {
    staticClass: "badge success"
  }, [_vm._v(_vm._s(_vm.pendingInvitations.length + _vm.pendingInvitationsToAccept.length))]) : _vm._e()]), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.invitations")))])])], 1)] : _vm._e(), _c('hr'), _c('li', [_c('router-link', {
    class: {
      loading: _vm.chatStatus == _vm.STATUS.LOADING
    },
    attrs: {
      "to": {
        name: "Chat",
        params: _vm.defaultRouteParams
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comments-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.chat")))])])], 1), _vm._l((_vm.listOfUsers), function(contact) {
    return _c('li', [_c('a', {
      staticClass: "chatUser",
      class: {
        active: _vm.isQuickChat([contact]),
          new: _vm.chatDataFor([_vm.user, contact]) && _vm.chatDataFor([_vm.user, contact]).status == _vm.STATUS.NEW,
          online: _vm.userIsOnline(contact)
      },
      on: {
        "click": function($event) {
          return _vm.openChatConversation(contact)
        }
      }
    }, [_c('vue-object-img', {
      attrs: {
        "object": contact
      }
    }), _c('span', [_vm._v(_vm._s(_vm.$t("sidemenu.discussWith")) + " " + _vm._s(contact.name))])], 1)])
  })], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b94b624e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainWrapper/SidebarMenu.vue
// module id = 1282
// module chunks = 1